export default __webpack_public_path__ + "static/media/tribute-memorials-logo.6effe83c.jpg";